// src/components/Terms.js
import React, { useEffect } from 'react';
import Header from '../components/Header';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import FooterMain from './FooterMain';

const Terms = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  
  const currentLang = lang || (navigator.language?.split('-')[0] === 'it' ? 'it' : 'en');
  
  const getLocalizedPath = (path) => {
    return `/${currentLang}${path}`;
  };
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="App min-h-screen bg-white text-black transition-colors duration-300">
      <Header />
      <div className="flex justify-center p-8">
        <div className="w-full max-w-6xl bg-white text-gray-900 p-8 rounded-lg shadow-lg">
          <h1 className="text-5xl font-bold mb-4 text-center">{t('terms.title')}</h1>
          <p className="text-justify">{t('terms.intro')}</p>

          <h2 className="text-2xl font-semibold mt-6">{t('terms.registration.title')}</h2>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li>{t('terms.registration.item1')}</li>
            <li>{t('terms.registration.item2')}</li>
            <li>{t('terms.registration.item3')}</li>
            <li>{t('terms.registration.item4')}</li>
            <li>{t('terms.registration.item5')}</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-6 ">{t('terms.platform.title')}</h2>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li>{t('terms.platform.item1')}</li>
            <li>{t('terms.platform.item2')}</li>
            <li>{t('terms.platform.item3')}</li>
            <li>{t('terms.platform.item4')}</li>
            <li>{t('terms.platform.item5')}</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-6">{t('terms.affiliate.title')}</h2>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li>{t('terms.affiliate.item1')}</li>
            <li>{t('terms.affiliate.item2')}</li>
            <li>{t('terms.affiliate.item3')}</li>
            <li>{t('terms.affiliate.item4')}</li>
            <li>{t('terms.affiliate.item5')}</li>
            <li>{t('terms.affiliate.item6')}</li>
            <li>{t('terms.affiliate.item7')}</li>
            <li>{t('terms.affiliate.item8')}</li>
            <li>{t('terms.affiliate.item9')}</li>
            <li>{t('terms.affiliate.item10')}</li>
            <li>{t('terms.affiliate.item11')}</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-6">{t('terms.commissions.title')}</h2>
          <ul className="ml-8 text-justify space-y-2 list-disc">
            <li>{t('terms.commissions.item1')}</li>
            <li>{t('terms.commissions.item2')}</li>
            <li>{t('terms.commissions.item3')}</li>
            <li>{t('terms.commissions.item4')}</li>
          </ul>
        </div>
      </div>
      <FooterMain />
    </div>
  );
};

export default Terms;
